import BaseModel from './BaseModel';

/**
 * Model for Policyholder Implementation Status
 * Handles data transformation from backend to frontend
 */
class PolicyHolderImplementationStatusModel extends BaseModel {
  static STAGE_MAPPING = {
    initial_contact: 'Initial Contact',
    demoing: 'Demoing',
    deciding: 'Deciding',
    in_training_1: 'Training 1',
    in_training_2: 'Training 2',
    in_training_3: 'Training 3',
    in_training_4: 'Training 4',
    live: 'Live',
    lost: 'Lost',
    unqualified: 'Unqualified',
    demo_rejected: 'Demo Declined',
  };

  // Stages that should be grouped under "in_training" for filtering
  static TRAINING_CATEGORY_STAGES = ['in_training_1', 'in_training_2', 'in_training_3', 'in_training_4'];

  // Stages that should be grouped under "lost" for filtering
  static LOST_CATEGORY_STAGES = ['lost', 'unqualified', 'demo_rejected'];

  init(data) {
    this.id = data.id;
    this.company_id = data.company_id;
    this.policyholder_name = data.policyholder_name;
    this.stage = data.stage;
    this.contact_person = data.contact_person;
    this.last_login = data.last_login;
    this.days_in_stage = data.days_in_stage;
  }

  /**
   * Get the formatted stage display name
   */
  get stageDisplay() {
    return PolicyHolderImplementationStatusModel.STAGE_MAPPING[this.stage] || this.stage;
  }

  /**
   * Convert to object for table display
   */
  toTableFormat() {
    return {
      id: this.id,
      company_id: this.company_id,
      policyholder_name: this.policyholder_name,
      stage: this.stageDisplay, // Use formatted stage name
      contact_person: this.contact_person,
      last_login: this.last_login,
      days_in_stage: this.days_in_stage,
    };
  }

  /**
   * Create multiple instances from API response array
   */
  static createListFromResponse(dataArray) {
    return dataArray.map(data => new PolicyHolderImplementationStatusModel(data));
  }
}

export default PolicyHolderImplementationStatusModel;
